{
  "INBOX_MGMT": {
    "HEADER": "Zarządzanie skrzynkami",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Learn more about inboxes",
    "RECONNECT": {
      "BUTTON": "Połącz ponownie",
      "FACEBOOK": "Połączenie z Facebookiem wygasło lub zostało cofnięte. Wiadomości wysłane do strony nie trafiają do tej skrzynki, a odpowiedzi mogą się nie wysłać. Osoba, która zarządza stroną na Facebooku, musi kliknąć Połącz ponownie i zalogować się do Facebooka.",
      "INSTAGRAM": "Połączenie z Instagramem wygasło lub zostało cofnięte. Wiadomości wysłane na konto nie trafiają do tej skrzynki, a odpowiedzi mogą się nie wysłać. Kliknij Połącz ponownie i zaloguj się na to samo konto Instagram. Inne konto utworzy nową skrzynkę.",
      "GOOGLE": "Połączenie z Google wygasło lub zostało cofnięte. Nowe e-maile nie trafiają do tej skrzynki, a odpowiedzi mogą się nie wysłać. Kliknij Połącz ponownie i zaloguj się do Google jako {email}.",
      "MICROSOFT": "Połączenie z Microsoft wygasło lub zostało cofnięte. Nowe e-maile nie trafiają do tej skrzynki, a odpowiedzi mogą się nie wysłać. Kliknij Połącz ponownie i zaloguj się do Microsoft jako {email}.",
      "ALLEGRO": "Połączenie z Allegro wygasło lub zostało cofnięte. Wiadomości od kupujących nie trafiają do tej skrzynki, a odpowiedzi mogą się nie wysłać. Kliknij Połącz ponownie i zaloguj się do Allegro jako sprzedawca {seller}. Inne konto sprzedawcy utworzy nową skrzynkę.",
      "IMAP_LOGIN": "Serwer pocztowy odrzuca logowanie IMAP jako {login}. Nowe e-maile nie docierają do tej skrzynki. Sprawdź login i hasło IMAP na karcie {tab} i zapisz je. Nadal próbujemy się zalogować, a skrzynka wznowi pracę, gdy tylko logowanie się powiedzie.",
      "WHATSAPP": "Połączenie z WhatsAppem wygasło lub zostało cofnięte. Załączniki od klientów nie docierają do tej skrzynki, a odpowiedzi mogą się nie udać. Kliknij Połącz ponownie, zaloguj się do Facebooka i ponownie wybierz numer {phone}."
    },
    "LIST": {
      "404": "Nie ma żadnych skrzynek odbiorczych przypisanych do tego konta.",
      "RECONNECT_REQUIRED": "Wymagane ponowne połączenie"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Wybierz kanał",
        "BODY": "Wybierz dostawcę, którego chcesz zintegrować z czatem."
      },
      "INBOX": {
        "TITLE": "Utwórz skrzynkę odbiorczą",
        "BODY": "Uwierzytelnij swoje konto i utwórz skrzynkę odbiorczą."
      },
      "AGENT": {
        "TITLE": "Dodaj agentów",
        "BODY": "Dodaj agentów do utworzonej skrzynki odbiorczej."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Wszystko jest gotowe!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Nazwa skrzynki odbiorczej",
        "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej (np. Acme Inc).",
        "ERROR": "Wprowadź poprawną nazwę skrzynki odbiorczej"
      },
      "WEBSITE_NAME": {
        "LABEL": "Nazwa strony",
        "PLACEHOLDER": "Wprowadź nazwę swojej witryny (np. Acme Inc.)."
      },
      "INTERNAL_NAME": {
        "LABEL": "Nazwa wewnętrzna",
        "PLACEHOLDER": "Nazwa skrzynki odbiorczej wyświetlana w panelu",
        "ERROR": "Wprowadź unikalną nazwę wewnętrzną"
      },
      "FB": {
        "HELP": "PS: Logując się, uzyskujemy dostęp tylko do wiadomości na Twojej stronie. Nigdy nie będziemy mieli dostępu do Twoich prywatnych wiadomości.",
        "CHOOSE_PAGE": "Wybierz stronę",
        "CHOOSE_PLACEHOLDER": "Wybierz stronę z listy",
        "INBOX_NAME": "Nazwa skrzynki odbiorczej",
        "ADD_NAME": "Dodaj nazwę skrzynki odbiorczej",
        "PICK_NAME": "Pick a Name for your Inbox",
        "PICK_A_VALUE": "Wybierz wartość",
        "CREATE_INBOX": "Utwórz skrzynkę odbiorczą"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Kontynuuj z Instagram",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Podłącz swój profil Instagram",
        "HELP": "Aby dodać swój profil Instagram jako kanał, musisz uwierzytelnić swój profil Instagram, klikając \"Kontynuuj z Instagram\" ",
        "ERROR_MESSAGE": "Wystąpił błąd podczas łączenia z Instagramem, spróbuj ponownie",
        "ERROR_AUTH": "Wystąpił błąd podczas łączenia z Instagramem, spróbuj ponownie",
        "NEW_INBOX_SUGGESTION": "To konto Instagram było wcześniej powiązane z inną skrzynką odbiorczą i zostało teraz przeniesione tutaj. Wszystkie nowe wiadomości pojawią się tutaj. Stara skrzynka odbiorcza nie będzie już mogła wysyłać ani odbierać wiadomości dla tego konta.",
        "DUPLICATE_INBOX_BANNER": "To konto Instagram zostało przeniesione do nowej skrzynki odbiorczej kanału Instagram. Nie będziesz już mógł wysyłać/odbierać wiadomości Instagram z tej skrzynki."
      },
      "TWITTER": {
        "HELP": "Aby dodać swój profil na Twitterze jako kanał, musisz uwierzytelnić swój profil Twittera, klikając „Zaloguj się przez Twitter”",
        "ERROR_MESSAGE": "Wystąpił błąd podczas łączenia z Twitterem. Spróbuj ponownie",
        "TWEETS": {
          "ENABLE": "Tworzenie konwersacji na podstawie wspomnianych tweetów"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Kanał strony internetowej",
        "DESC": "Utwórz kanał dla swojej strony internetowej i zacznij obsługiwać klientów za pomocą naszego widżetu na stronie.",
        "LOADING_MESSAGE": "Tworzenie kanału wsparcia dla strony internetowej",
        "CHANNEL_AVATAR": {
          "LABEL": "Awatar kanału"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL webhooka",
          "PLACEHOLDER": "Please enter your Webhook URL",
          "ERROR": "Wprowadź poprawny adres URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Domena strony internetowej",
          "PLACEHOLDER": "Wprowadź domenę strony (np. acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Tytuł powitania",
          "PLACEHOLDER": "Cześć!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Tagline powitania",
          "PLACEHOLDER": "Łatwo się z nami skontaktujesz. Zadaj pytanie lub podziel się opinią."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Wiadomość powitalna kanału",
          "PLACEHOLDER": "Firma Acme Inc zazwyczaj odpowiada w ciągu kilku godzin."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Włącz powitanie dla kanału",
          "HELP_TEXT": "Automatycznie wysyłaj wiadomość powitalną, gdy utworzona zostanie nowa rozmowa.",
          "ENABLED": "Włączone",
          "DISABLED": "Wyłączone"
        },
        "REPLY_TIME": {
          "TITLE": "Ustaw czas odpowiedzi",
          "IN_A_FEW_MINUTES": "W ciągu kilku minut",
          "IN_A_FEW_HOURS": "W ciągu kilku godzin",
          "IN_A_DAY": "W ciągu dnia",
          "HELP_TEXT": "Czas odpowiedzi będzie wyświetlany w widżecie czatu na żywo."
        },
        "WIDGET_COLOR": {
          "LABEL": "Kolor widżetu",
          "PLACEHOLDER": "Zaktualizuj kolor widżetu używany w widżecie"
        },
        "SUBMIT_BUTTON": "Utwórz skrzynkę odbiorczą",
        "API": {
          "ERROR_MESSAGE": "Nie udało się utworzyć kanału dla strony internetowej. Spróbuj ponownie"
        }
      },
      "TWILIO": {
        "TITLE": "Kanał Twilio SMS/WhatsApp",
        "DESC": "Zintegruj Twilio i rozpocznij obsługę klientów za pomocą wiadomości SMS lub WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "ID konta",
          "PLACEHOLDER": "Wprowadź ID konta Twilio",
          "ERROR": "To pole jest wymagane"
        },
        "API_KEY": {
          "USE_API_KEY": "Use API Key Authentication",
          "LABEL": "API Key SID",
          "PLACEHOLDER": "Please enter your API Key SID",
          "ERROR": "To pole jest wymagane"
        },
        "API_KEY_SECRET": {
          "LABEL": "API Key Secret",
          "PLACEHOLDER": "Please enter your API Key Secret",
          "ERROR": "To pole jest wymagane"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "ID usługi wiadomości",
          "PLACEHOLDER": "Wprowadź ID usługi wiadomości Twilio",
          "ERROR": "To pole jest wymagane",
          "USE_MESSAGING_SERVICE": "Użyj usługi wiadomości Twilio"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Typ kanału",
          "ERROR": "Wybierz typ kanału"
        },
        "AUTH_TOKEN": {
          "LABEL": "Token uwierzytelniania",
          "PLACEHOLDER": "Wprowadź token uwierzytelniania Twilio",
          "ERROR": "To pole jest wymagane"
        },
        "CHANNEL_NAME": {
          "LABEL": "Nazwa skrzynki odbiorczej",
          "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
          "ERROR": "To pole jest wymagane"
        },
        "PHONE_NUMBER": {
          "LABEL": "Numer telefonu",
          "PLACEHOLDER": "Wprowadź numer telefonu, z którego będzie wysyłana wiadomość.",
          "ERROR": "Podaj poprawny numer telefonu, który zaczyna się od znaku „+” i nie zawiera spacji."
        },
        "API_CALLBACK": {
          "TITLE": "Adres URL zwrotny API",
          "SUBTITLE": "Musisz skonfigurować adres URL zwrotny wiadomości w Twilio z adresem URL podanym tutaj."
        },
        "SUBMIT_BUTTON": "Utwórz kanał Twilio",
        "API": {
          "ERROR_MESSAGE": "Nie udało się uwierzytelnić danych logowania Twilio. Spróbuj ponownie"
        }
      },
      "SMS": {
        "TITLE": "Kanał SMS",
        "DESC": "Rozpocznij obsługę klientów za pomocą wiadomości SMS.",
        "PROVIDERS": {
          "LABEL": "Dostawca API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Przepustowość",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału SMS"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID konta",
            "PLACEHOLDER": "Wprowadź ID konta przepustowości",
            "ERROR": "To pole jest wymagane"
          },
          "API_KEY": {
            "LABEL": "Klucz API",
            "PLACEHOLDER": "Please enter your Bandwidth API Key",
            "ERROR": "To pole jest wymagane"
          },
          "API_SECRET": {
            "LABEL": "Sekret API",
            "PLACEHOLDER": "Please enter your Bandwidth API Secret",
            "ERROR": "To pole jest wymagane"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikacji",
            "PLACEHOLDER": "Wprowadź ID aplikacji przepustowości",
            "ERROR": "To pole jest wymagane"
          },
          "INBOX_NAME": {
            "LABEL": "Nazwa skrzynki odbiorczej",
            "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
            "ERROR": "To pole jest wymagane"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numer telefonu",
            "PLACEHOLDER": "Wprowadź numer telefonu, z którego będzie wysyłana wiadomość.",
            "ERROR": "Podaj poprawny numer telefonu, który zaczyna się od znaku „+” i nie zawiera spacji."
          },
          "SUBMIT_BUTTON": "Utwórz kanał SMS",
          "API": {
            "ERROR_MESSAGE": "Nie udało się uwierzytelnić poświadczeń przepustowości. Spróbuj ponownie"
          },
          "API_CALLBACK": {
            "TITLE": "Adres URL zwrotny API",
            "SUBTITLE": "Musisz skonfigurować adres URL zwrotny wiadomości w przepustowości z adresem URL podanym tutaj."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Nazwa skrzynki odbiorczej",
            "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
            "ERROR": "To pole jest wymagane"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numer telefonu",
            "PLACEHOLDER": "Wprowadź numer telefonu, z którego będą wysyłane wiadomości.",
            "ERROR": "Podaj prawidłowy numer telefonu zaczynający się od znaku `+`."
          },
          "SUBMIT_BUTTON": "Utwórz kanał SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Nie mogliśmy utworzyć kanału SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Nazwa skrzynki odbiorczej",
            "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
            "ERROR": "To pole jest wymagane"
          },
          "PHONE_NUMBER": {
            "LABEL": "Numer telefonu",
            "PLACEHOLDER": "Wprowadź numer telefonu, z którego będą wysyłane wiadomości.",
            "ERROR": "Podaj prawidłowy numer telefonu zaczynający się od znaku `+`."
          },
          "SUBMIT_BUTTON": "Utwórz kanał DIDWW",
          "API": {
            "ERROR_MESSAGE": "Nie mogliśmy utworzyć kanału DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Dostawca API",
          "WHATSAPP_CLOUD": "Chmura WhatsApp"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Musisz skonfigurować adres URL webhooka i token weryfikacyjny w portalu dewelopera Facebooka z podanymi tutaj wartościami.",
          "WEBHOOK_URL": "Adres URL webhooka",
          "WEBHOOK_VERIFICATION_TOKEN": "Token weryfikacyjny webhooka"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Szybka konfiguracja z Meta",
          "DESC": "Zostaniesz przekierowany do Meta, aby zalogować się do swojego konta WhatsApp Business. Dostęp administratora ułatwi i przyspieszy konfigurację.",
          "BENEFITS": {
            "EASY_SETUP": "Bez konieczności ręcznej konfiguracji",
            "SECURE_AUTH": "Bezpieczne uwierzytelnianie oparte na OAuth",
            "AUTO_CONFIG": "Automatyczna konfiguracja webhooka i numeru telefonu"
          },
          "SUBMIT_BUTTON": "Połącz z WhatsApp Business",
          "AUTH_PROCESSING": "Uwierzytelnianie w Meta",
          "WAITING_FOR_BUSINESS_INFO": "Dokończ konfigurację firmy w oknie Meta...",
          "PROCESSING": "Konfigurowanie konta WhatsApp Business",
          "CANCELLED": "Rejestracja WhatsApp została anulowana",
          "WAITING_FOR_AUTH": "Oczekiwanie na uwierzytelnienie...",
          "INVALID_BUSINESS_DATA": "Otrzymano nieprawidłowe dane firmy z Facebooka. Spróbuj ponownie.",
          "SIGNUP_ERROR": "Wystąpił błąd rejestracji",
          "SDK_LOAD_ERROR": "Nie udało się załadować Facebook SDK. Spróbuj ponownie.",
          "AUTH_NOT_COMPLETED": "Uwierzytelnianie nie zostało ukończone. Uruchom proces ponownie.",
          "SUCCESS_FALLBACK": "Konto WhatsApp Business zostało pomyślnie skonfigurowane",
          "RECONNECTED": "Kanał WhatsApp został ponownie połączony"
        },
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału WhatsApp"
        }
      },
      "API_CHANNEL": {
        "TITLE": "Kanał API",
        "DESC": "Zintegruj kanał API i rozpocznij obsługę klientów.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "WEBHOOK_URL": {
          "LABEL": "Adres URL webhooka",
          "SUBTITLE": "Configure the URL where you want to receive callbacks on events.",
          "PLACEHOLDER": "Adres URL webhooka"
        },
        "SUBMIT_BUTTON": "Utwórz kanał API",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału API"
        }
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce channel",
        "DESC": "Integrate with Salesforce channel and start supporting your customers.",
        "CHANNEL_NAME": {
          "LABEL": "Channel Name",
          "PLACEHOLDER": "Please enter a channel name",
          "ERROR": "This field is required"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce API URL",
          "SUBTITLE": "Configure the base URL for your Salesforce instance.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "This field is required"
        },
        "KEY_ID": {
          "LABEL": "Key ID",
          "SUBTITLE": "Key ID for your Salesforce channel.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "This field is required"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret for your Salesforce channel.",
          "PLACEHOLDER": "*****",
          "ERROR": "This field is required"
        },
        "SUBMIT_BUTTON": "Create Salesforce Channel",
        "API": {
          "ERROR_MESSAGE": "We were not able to save the Salesforce channel"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook URL",
          "SUBTITLE": "You have to configure the webhook URL in Salesforce with the URL mentioned here."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer Token",
          "SUBTITLE": "Use this bearer token for authentication when configuring the webhook in Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Override Email Sender",
          "SUBTITLE": "If set, this email address will be used as the sender for all outgoing emails instead of the conversation's source email.",
          "PLACEHOLDER": "e.g. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Kanał Allegro",
        "DESC": "Podłącz konto sprzedawcy Allegro i odpowiadaj na wiadomości z jego Centrum Wiadomości w centrum kontaktowym.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa skrzynki odbiorczej",
          "SUBTITLE": "Nazwa tej skrzynki odbiorczej widoczna dla agentów.",
          "PLACEHOLDER": "Wprowadź nazwę skrzynki odbiorczej",
          "ERROR": "To pole jest wymagane"
        },
        "SUBMIT_BUTTON": "Zaloguj się przez Allegro",
        "API": {
          "ERROR_MESSAGE": "Wystąpił błąd podczas łączenia z Allegro, spróbuj ponownie"
        },
        "SELLER_LOGIN": {
          "TITLE": "Logowanie do Allegro",
          "SUBTITLE": "Konto sprzedawcy, którego wiadomości ta skrzynka odbiorcza odczytuje i na które odpowiada."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kanał Kaufland",
        "DESC": "Odpowiadaj na wiadomości w zgłoszeniach, które kupujący wysyłają Ci na platformie Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "32-znakowy Client Key ze strony ustawień API Twojego konta sprzedawcy Kaufland.",
          "PLACEHOLDER": "klucz 32-znakowy",
          "ERROR": "Wprowadź 32-znakowy Client Key"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "64-znakowy Secret Key należący do Client Key. Kaufland pokazuje go tylko raz i nigdy nie odsyła go na tę stronę.",
          "PLACEHOLDER": "klucz 64-znakowy",
          "ERROR": "Wprowadź 64-znakowy Secret Key"
        },
        "SUBMIT_BUTTON": "Utwórz kanał Kaufland",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału Kaufland"
        },
        "DISCONNECTED": {
          "TITLE": "Rozłączono",
          "MESSAGE": "Kaufland odrzucił te klucze API. Wprowadź ponownie Client Key i Secret Key, aby ponownie połączyć tę skrzynkę odbiorczą."
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Kanał e-mail",
        "DESC": "Integrate your email inbox.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "Adres e-mail, na który klienci wysyłają zgłoszenia",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Utwórz kanał e-mail",
        "API": {
          "ERROR_MESSAGE": "Nie udało nam się zapisać kanału e-mail"
        },
        "FINISH_MESSAGE": "Zacznij przekierowywać wiadomości na poniższy adres e-mail."
      },
      "LINE_CHANNEL": {
        "TITLE": "Kanał LINE",
        "DESC": "Zintegruj kanał LINE i rozpocznij obsługę klientów.",
        "CHANNEL_NAME": {
          "LABEL": "Nazwa kanału",
          "PLACEHOLDER": "Wprowadź nazwę kanału",
          "ERROR": "To pole jest wymagane"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "ID kanału LINE",
          "PLACEHOLDER": "ID kanału LINE"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "Sekret kanału LINE",
          "PLACEHOLDER": "Sekret kanału LINE"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "Token kanału LINE",
          "PLACEHOLDER": "Token kanału LINE"
        },
        "SUBMIT_BUTTON": "Utwórz kanał LINE",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału LINE"
        },
        "API_CALLBACK": {
          "TITLE": "Adres URL zwrotny API",
          "SUBTITLE": "Musisz skonfigurować adres URL webhooka w aplikacji LINE z podanym tutaj adresem URL."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Kanał Telegram",
        "DESC": "Zintegruj kanał Telegram i rozpocznij obsługę klientów.",
        "BOT_TOKEN": {
          "LABEL": "Token bota",
          "SUBTITLE": "Skonfiguruj token bota, który otrzymałeś od Telegram BotFather.",
          "PLACEHOLDER": "Token bota"
        },
        "SUBMIT_BUTTON": "Utwórz kanał Telegram",
        "API": {
          "ERROR_MESSAGE": "Nie udało się zapisać kanału Telegram"
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Phone calls",
        "DESC": "Setup which phone calls will show under this inbox.",
        "NAME": {
          "LABEL": "Inbox name",
          "SUBTITLE": "Pick an easily identifiable name."
        },
        "PHONE_NUMBER": {
          "LABEL": "Phone number",
          "SUBTITLE": "Enter phone numbers that belong to this inbox, you can add more numbers later.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Create Phone calls inbox",
        "API": {
          "ERROR_MESSAGE": "We were not able to create the inbox"
        }
      },
      "AUTH": {
        "TITLE": "Wybierz kanał",
        "DESC": "Czat obsługuje jako kanały widżety czatu na żywo, Facebook Messenger, WhatsApp, e-maile itp. Jeśli chcesz zbudować własny kanał, możesz go utworzyć za pomocą kanału API. Aby rozpocząć, wybierz jeden z poniższych kanałów."
      },
      "AGENTS": {
        "TITLE": "Agenci",
        "DESC": "Tutaj możesz dodać agentów do zarządzania swoją nowo utworzoną skrzynką odbiorczą. Tylko ci wybrani agenci będą mieli dostęp do Twojej skrzynki odbiorczej. Agenci, którzy nie są częścią tej skrzynki odbiorczej nie będą mogli zobaczyć ani odpowiadać na wiadomości w tej skrzynce odbiorczej podczas logowania. <br> <b>PS:</b> Jako administrator, jeśli potrzebujesz dostępu do wszystkich skrzynek odbiorczych, powinieneś dodać siebie jako agenta do wszystkich skrzynek odbiorczych, które tworzysz.",
        "VALIDATION_ERROR": "Add at least one agent to your new Inbox",
        "PICK_AGENTS": "Wybierz agentów dla skrzynki odbiorczej"
      },
      "DETAILS": {
        "TITLE": "Skonfiguruj szczegóły skrzynki odbiorczej",
        "DESC": "Z listy rozwijanej poniżej wybierz stronę na Facebooku, którą chcesz połączyć z czatwootem. Możesz również podać własną nazwę swojej skrzynki odbiorczej w celu lepszej identyfikacji."
      },
      "FINISH": {
        "TITLE": "Twoja skrzynka odbiorcza jest gotowa!",
        "DESC": "Pomyślnie zakończyłeś integrację strony na Facebooku z czatem. Następnym razem, gdy klient komunikuje Twoją stronę, konwersacja pojawi się automatycznie na twojej skrzynce odbiorczej.<br>Dostarczamy również skrypt widżetu, który można łatwo dodać do swojej witryny. Gdy tylko będzie on dostępny na Twojej stronie internetowej, klienci mogą wysyłać Ci wiadomości bezpośrednio z Twojej strony bez pomocy żadnego zewnętrznego narzędzia, a konwersacja pojawi się tutaj, na czacie.<br>Coś, co? Cóż, na pewno spróbujemy być :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Wybierz dostawcę poczty e-mail",
        "DESCRIPTION": "Wybierz dostawcę poczty e-mail z poniższej listy. Jeśli nie widzisz swojego dostawcy poczty e-mail na liście, możesz wybrać opcję innego dostawcy i podać poświadczenia IMAP i SMTP."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft",
        "DESCRIPTION": "Kliknij przycisk Zaloguj się za pomocą Microsoft, aby rozpocząć. Nastąpi przekierowanie do strony logowania przez e-mail. Po zaakceptowaniu wymaganych uprawnień zostaniesz przekierowany z powrotem do etapu tworzenia skrzynki odbiorczej.",
        "EMAIL_PLACEHOLDER": "Wprowadź adres e-mail",
        "SIGN_IN": "Sign in with Microsoft",
        "ERROR_MESSAGE": "Wystąpił błąd połączenia z Microsoft, spróbuj ponownie"
      },
      "GOOGLE": {
        "TITLE": "Google Email",
        "DESCRIPTION": "Click on the Sign in with Google button to get started. You will redirected to the email sign in page. Once you accept the requested permissions, you would be redirected back to the inbox creation step.",
        "SIGN_IN": "Sign in with Google",
        "EMAIL_PLACEHOLDER": "Wprowadź adres e-mail",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      }
    },
    "DETAILS": {
      "LOADING_FB": "Uwierzytelnianie za pomocą Facebooka...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Coś poszło nie tak. Proszę odświeżyć stronę...",
      "ERROR_FB_UNAUTHORIZED": "You're not authorized to perform this action. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Please ensure you have access to the Facebook page with full control. You can read more about Facebook roles <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Nie udało się utworzyć skrzynki odbiorczej. Spróbuj ponownie.",
      "CREATING_CHANNEL": "Tworzenie skrzynki odbiorczej...",
      "TITLE": "Skonfiguruj szczegóły skrzynki odbiorczej",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Dodaj agentów",
      "ADD_AGENTS": "Dodawanie agentów do skrzynki odbiorczej..."
    },
    "FINISH": {
      "TITLE": "Twoja skrzynka odbiorcza jest gotowa!",
      "MESSAGE": "Możesz teraz kontaktować się z klientami za pośrednictwem nowego kanału. Szczęśliwy wspierający",
      "BUTTON_TEXT": "Zabierz mnie tam",
      "MORE_SETTINGS": "Więcej ustawień",
      "WEBSITE_SUCCESS": "Pomyślnie zakończyłeś tworzenie kanału internetowego. Skopiuj poniższy kod i wklej go na swojej stronie. Następnym razem, gdy klient korzysta z czatu na żywo, konwersacja pojawi się automatycznie na twojej skrzynce odbiorczej."
    },
    "REAUTH": "Ponowna autoryzacja",
    "VIEW": "Widok",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Ustawienia skrzynki odbiorczej zostały zaktualizowane",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatyczne przypisanie zaktualizowane pomyślnie",
        "ERROR_MESSAGE": "Nie mogliśmy zaktualizować ustawień skrzynki odbiorczej. Spróbuj ponownie później."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Sender name",
        "SUB_TEXT": "Select the name shown to your customer when they receive emails from your agents.",
        "FOR_EG": "For eg:",
        "FRIENDLY": {
          "TITLE": "Przyjazna",
          "FROM": "od",
          "SUBTITLE": "Add the name of the agent who sent the reply in the sender name to make it friendly."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesjonalna",
          "SUBTITLE": "Use only the configured business name as the sender name in the email header."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Configure your business name",
          "PLACEHOLDER": "Enter your business name",
          "SAVE_BUTTON_TEXT": "Zapisz"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Brak"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Enabled",
        "DISABLED": "Disabled"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_HMAC": {
        "LABEL": "Włącz"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Włączone",
        "DISABLED": "Wyłączone"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Enable synchronization of incoming emails"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Enable Custom Email Domain (paid service)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Enable Facebook comments processing"
      },
      "SIGNATURE": {
        "TITLE": "HTML Signature",
        "SUB_TEXT": "This signature will be added to the footer of every message sent from this inbox.",
        "HTML_CONTENT": "HTML code",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} will be replaced with the name of the agent.\n{'{{'}email{'}}'} will be replaced with the email address of the agent who sent the email.\n{'{{'}position{'}}'} will be replaced with the position of the agent.\n{'{{'}custom_line{'}}'} will be replaced with the custom line of the agent.\n{'{{'}email_signature_picture{'}}'} will be replaced with the URL of the agent's email signature picture (not an image tag) — use it as an image source (the src of an img tag).",
        "PREVIEW": "Preview"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Podpisy według kraju",
        "SUB_TEXT": "Odpowiedź otrzymuje podpis dla kraju kupującego.",
        "HELP": "Odpowiedź jest podpisywana według kraju rozmowy: sklepu Kaufland, platformy zamówienia z Allegro, a w przeciwnym razie języka, w którym pisze kupujący. Gdy kraj jest nieznany lub nie ma tu dla niego podpisu, używany jest podpis HTML powyżej. Platformy handlowe zabraniają linków do Twojej strony i danych kontaktowych, dlatego ogranicz się do pozdrowienia i {'{{'}name{'}}'}.",
        "EMPTY": "Nie masz jeszcze podpisów dla krajów, dlatego odpowiedzi używają podpisu HTML powyżej.",
        "COUNTRY": "Wybierz kraj",
        "ADD": "Dodaj podpis dla kraju",
        "REMOVE": "Usuń"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Phone Number Dialing Prefix",
        "PLACEHOLDER": "Enter prefix for correct call routing (e.g., *99)",
        "HELP_TEXT": "This prefix will be automatically prepended to contact phone numbers when dialing from this inbox."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Tekst przycisku „rozwiążemy później”",
        "PLACEHOLDER": "np. Rozwiążemy ten temat e-mailem. Teraz chcę zapytać o coś innego.",
        "HELP_TEXT": "Tekst przycisku w widżecie, który pozwala odwiedzającemu opuścić bieżący temat i zapytać o coś innego. Jeśli pole zostanie puste, zostanie użyty domyślny tekst w języku odwiedzającego."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Auto-snooze missed calls for X minutes",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automatically snooze missed calls for specified number of minutes. Leave empty or 0 to disable."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Rozwiąż nieodebrane połączenie po X nieudanych oddzwonieniach",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Gdy na nieodebrane połączenie oddzwoniono X razy, a klient nie odebrał, jest ono automatycznie rozwiązywane i dodawana jest notatka prywatna. Pozostaw puste lub wpisz 0, aby wyłączyć."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Question Suggestions",
        "SUB_TEXT": "Configure predefined questions that customers can use to interact with your agents.",
        "QUESTIONS_LABEL": "Questions",
        "ADD_QUESTION": "Add Question",
        "QUESTION": "Question",
        "REMOVE": "Remove",
        "QUESTION_TEXT": "Text displayed in the bubble.",
        "QUESTION_TEXT_PLACEHOLDER": "Required",
        "QUESTION_PAYLOAD": "Text sent when clicked.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Optional",
        "SAVE": "Save",
        "NO_BOT_MESSAGE": "To generate additional AI suggestions, please connect a bot.",
        "BOT_CONNECTED_MESSAGE": "AI question suggestions from the bot can be activated in its",
        "BOT_SETTINGS_LINK": "settings"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatywne adresy e-mail",
        "SUB_TEXT": "Dodatkowe adresy, które ta skrzynka odbiorcza powinna traktować jako własne podczas odbierania przekazywanej poczty.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Dodaj",
        "REMOVE": "Usuń",
        "EMPTY": "Nie skonfigurowano alternatywnych adresów e-mail.",
        "HELP_TEXT": "Gdy wiadomość e-mail dotrze na jeden z tych adresów jako odbiorca, odpowiedzi będą wysyłane z tego samego adresu jako nadawcy. Upewnij się, że Twój wychodzący serwer SMTP zezwala na wysyłanie z tych adresów.",
        "SIGNATURE_LABEL": "Podpis",
        "PRIMARY_SIGNATURE": "Podstawowy (domyślny)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Dodatkowe podpisy",
        "SUB_TEXT": "Zdefiniuj tutaj dodatkowe podpisy, a następnie przypisz je do alternatywnych adresów e-mail poniżej.",
        "OPTION": "Podpis {number}",
        "ADD": "Dodaj podpis",
        "REMOVE": "Usuń",
        "HELP_TEXT": "Gdy odpowiedź jest wysyłana z alternatywnego adresu e-mail, używany jest przypisany do niego podpis zamiast podpisu skrzynki odbiorczej. Alternatywne adresy e-mail pozostawione na „Podstawowy (domyślny)” korzystają z podpisu skrzynki odbiorczej."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Usuń",
      "AVATAR_DELETE_BUTTON_TEXT": "Usuń awatar",
      "DELETE_REQUESTED_TOOLTIP": "This inbox is marked for deletion",
      "RESTORE_BUTTON_TEXT": "Restore",
      "CONFIRM": {
        "TITLE": "Potwierdź usunięcie",
        "MESSAGE": "Czy na pewno chcesz usunąć ",
        "PLACE_HOLDER": "Wpisz {inboxName}, aby potwierdzić",
        "YES": "Tak, usuń ",
        "NO": "Nie, zachowaj "
      },
      "API": {
        "SUCCESS_MESSAGE": "Skrzynka odbiorcza została usunięta",
        "MARKED_FOR_DELETION_MESSAGE": "Inbox marked for deletion",
        "RESTORE_SUCCESS_MESSAGE": "Inbox restored successfully",
        "ERROR_MESSAGE": "Nie można usunąć skrzynki odbiorczej. Spróbuj ponownie później.",
        "RESTORE_ERROR_MESSAGE": "Could not restore inbox. Please try again later.",
        "AVATAR_SUCCESS_MESSAGE": "Pomyślnie usunięto awatar skrzynki odbiorczej",
        "AVATAR_ERROR_MESSAGE": "Nie można usunąć awatara skrzynki odbiorczej. Spróbuj ponownie później."
      }
    },
    "TABS": {
      "SETTINGS": "Ustawienia",
      "COLLABORATORS": "Współpracownicy",
      "AUTOMATIC_PRIORITY": "Automatic Priority",
      "AUTOMATIC_LABELING": "Automatic Labeling",
      "CONFIGURATION": "Konfiguracja",
      "CAMPAIGN": "Kampania",
      "PRE_CHAT_FORM": "Formularz czatu wstępnego",
      "BUSINESS_HOURS": "Godziny pracy",
      "WIDGET_BUILDER": "Kreator widżetów",
      "BOT_CONFIGURATION": "Konfiguracja bota",
      "SLA": "SLA"
    },
    "SETTINGS": "Ustawienia",
    "FEATURES": {
      "LABEL": "Funkcje",
      "DISPLAY_FILE_PICKER": "Wyświetl selektor plików w widżecie",
      "DISPLAY_EMOJI_PICKER": "Wyświetl selektor emoji w widżecie",
      "ALLOW_END_CONVERSATION": "Umożliwienie użytkownikom zakończenia konwersacji z poziomu widżetu",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Pokaż przycisk 'Rozpocznij nową rozmowę' w nagłówku widżetu",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Ukryj pole tekstowe, gdy widoczny jest przycisk rozpoczęcia nowej rozmowy",
      "SHOW_HANDOFF_BUTTON": "Pokaż przycisk 'Przekaż do operatora' w nagłówku widżetu",
      "USE_INBOX_AVATAR_FOR_BOT": "Użyj nazwy skrzynki odbiorczej i awatara dla bota",
      "ALLOW_OFFLINE_REPLY": "Allow agents to send messages when contact is offline and email continuity is not available",
      "AUTO_CLOSE_OLD": "Mark all past calls from the same number as resolved after one is resolved",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automatically assign missed calls when making an outgoing call"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Skrypt Messengera",
      "MESSENGER_SUB_HEAD": "Umieść ten przycisk wewnątrz znacznika ciała",
      "INBOX_AGENTS": "Agenci",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Cooperators",
      "SELECT_PLACEHOLDER": "Select",
      "AGENTS_OR_TEAMS_INFO": "You can assign either agents or teams - not both simultaneously.",
      "AGENT_ASSIGNMENT": "Zadanie konwersacji",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualizacja ustawień przypisywania konwersacji",
      "UPDATE": "Aktualizuj",
      "ENABLE_EMAIL_COLLECT_BOX": "Włącz skrzynkę odbiorczą e-mail",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Włącz lub wyłącz skrzynkę zbierania wiadomości e-mail w nowej konwersacji",
      "AUTO_ASSIGNMENT": "Włącz automatyczne przypisanie",
      "ENABLE_CSAT": "Włącz CSAT",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Enable CSAT on each message",
      "SENDER_NAME_SECTION": "Enable Agent Name in Email",
      "ENABLE_CSAT_SUB_TEXT": "Włącz/Wyłącz ankietę CSAT(Customer satisfraction) po rozwiązaniu rozmowy",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Enable/Disable CSAT survey option for each message sent by agents",
      "SENDER_NAME_SECTION_TEXT": "Enable/Disable showing Agent's name in email, if disabled it will show business name",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Włącz ciągłość rozmowy przez e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Rozmowy będą kontynuowane przez e-mail, jeśli adres e-mail kontaktu jest dostępny.",
      "RESPOND_FROM_EMAIL": "Odpowiadaj z adresu e-mail",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "Wiadomości e-mail do klienta — zarówno odpowiedzi, jak i transkrypcje rozmowy — są wysyłane przy użyciu ustawień SMTP wybranej skrzynki e-mail, z wybranego adresu (własnego adresu skrzynki lub jednego z jej aliasów), a odpowiedzi klienta trafiają z powrotem na jej adres IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Transkrypcje rozmowy są wysyłane przy użyciu ustawień SMTP wybranej skrzynki e-mail, z wybranego adresu (własnego adresu skrzynki lub jednego z jej aliasów), a odpowiedzi trafiają z powrotem na jej adres IMAP.",
      "SHOW_WELCOME_SCREEN": "Show welcome screen",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Show the welcome screen when the widget is opened. If disabled, the widget will go directly to the conversation view.",
      "AUTO_CLOSE_PENDING": "Auto resolve AI chats after (hours)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Auto resolve AI chats after X hours of inactivity.",
      "LOCK_TO_SINGLE_CONVERSATION": "Blokada do pojedynczej rozmowy",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Włączanie lub wyłączanie wielu wątków dla tego samego kontaktu w tej skrzynce odbiorczej",
      "INBOX_UPDATE_TITLE": "Ustawienia skrzynki odbiorczej",
      "INBOX_UPDATE_SUB_TEXT": "Zaktualizuj ustawienia skrzynki odbiorczej",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Włącz lub wyłącz automatyczne przypisywanie nowych rozmów do agentów dodanych do tej skrzynki odbiorczej.",
      "HMAC_VERIFICATION": "Weryfikacja tożsamości użytkownika",
      "HMAC_DESCRIPTION": "In order to validate the user's identity, you can pass an `identifier_hash` for each user. You can generate a HMAC sha256 hash using the `identifier` with the key shown here.",
      "HMAC_ROTATE": {
        "BUTTON": "Wymień klucz",
        "TITLE": "Wymienić tajny klucz?",
        "WARNING": "Bieżący klucz traci ważność w chwili jego wymiany.",
        "WARNING_DETAIL": "Nie ma okresu przejściowego i nie można go przywrócić.",
        "IMPACT": "Twoje serwery muszą podpisywać użytkowników nowym kluczem. Każdy, kto nadal jest podpisany starym kluczem, nie przejdzie weryfikacji. Jeśli weryfikacja tożsamości jest wymagana, taka osoba nie będzie mogła rozpocząć rozmowy.",
        "CONFIRM": "Wymień klucz",
        "CANCEL": "Anuluj",
        "SUCCESS": "Tajny klucz został pomyślnie wymieniony",
        "ERROR": "Nie udało się wymienić tajnego klucza. Spróbuj ponownie"
      },
      "HMAC_LINK_TO_DOCS": "Więcej informacji można znaleźć tutaj.",
      "HMAC_MANDATORY_VERIFICATION": "Wymuś sprawdzanie tożsamości użytkownika",
      "HMAC_MANDATORY_DESCRIPTION": "If enabled, requests missing the `identifier_hash` will be rejected.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Wymuś nową rozmowę przy każdym załadowaniu widżetu",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Jeśli włączone, otwarcie widżetu w nowej karcie lub oknie rozpoczyna nową rozmowę.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Zapomnij kontakt przy rozpoczęciu nowej rozmowy",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Jeśli wyłączone, nowa rozmowa rozpoczęta z widżetu zachowuje poprzedni kontakt.",
      "INBOX_IDENTIFIER": "Identyfikator skrzynki odbiorczej",
      "INBOX_IDENTIFIER_SUB_TEXT": "Użyj tokenu `inbox_identifier` pokazanego tutaj, aby uwierzytelnić swoich klientów API.",
      "FORWARD_EMAIL_TITLE": "Przekaż do wiadomości e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Zacznij przekierowywać swoje wiadomości na następujący adres e-mail.",
      "EMAIL_FETCHING_ENABLED_TITLE": "Email Synchronization",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Enable automatic synchronization and downloading of incoming emails from this inbox",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Custom Email Domain",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Enable to use a custom email domain for outgoing emails",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "You can read more here.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook Comments",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Zezwalaj na wiadomości po rozwiązaniu konwersacji",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Zezwalaj użytkownikom końcowym na wysyłanie wiadomości nawet po zakończeniu konwersacji.",
      "WIDGET_STATUS_LABEL": "Widget Status",
      "WIDGET_STATUS_ENABLED": "Enabled",
      "WIDGET_STATUS_BUSINESS_HOURS": "Enabled during business hours",
      "WIDGET_STATUS_DISABLED": "Disabled",
      "WIDGET_STATUS_HELP_TEXT": "Control when the widget is shown to visitors on your website",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Aktualizacja ustawień formularza czatu wstępnego",
      "EXPLICIT_CSAT_LOCALE": "CSAT survey and Email Locale",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Choose the language for all customer emails including CSAT surveys, conversation transcripts, and email notifications",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Dziedzicz z konta",
      "INBOX_AGENTS_SUB_TEXT": "Dodaj lub usuń agentów z tej skrzynki odbiorczej",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Połączenie WhatsApp",
        "SUBTITLE": "Jak ta skrzynka jest połączona z WhatsAppem.",
        "PROVIDER": "Dostawca",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Połączono przez wbudowaną rejestrację Meta",
        "STATUS": "Status",
        "CONNECTED": "Połączono",
        "RECONNECT_HINT": "Kliknij Połącz ponownie w komunikacie powyżej.",
        "PHONE_NUMBER": "Numer telefonu",
        "BUSINESS_ACCOUNT": "ID konta WhatsApp Business",
        "OPEN_MANAGER": "Otwórz w WhatsApp Managerze",
        "PHONE_NUMBER_ID": "ID numeru telefonu",
        "TEMPLATES": "Szablony wiadomości",
        "TEMPLATES_COUNT": "Zatwierdzone: {approved} z {total}",
        "TEMPLATES_SYNCED": "Ostatnia synchronizacja: {date}",
        "TEMPLATES_NOT_SYNCED": "Jeszcze nie zsynchronizowano",
        "MANAGE_TEMPLATES": "Zarządzaj szablonami"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centrum pomocy",
      "PLACEHOLDER": "Wybierz Centrum pomocy",
      "SELECT_PLACEHOLDER": "Wybierz Centrum pomocy",
      "REMOVE": "Usuń Centrum pomocy",
      "SUB_TEXT": "Dołącz Centrum pomocy do skrzynki odbiorczej"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit automatycznego przypisywania",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Wprowadź wartość większą niż 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Ogranicz maksymalną liczbę wątków z tej skrzynki odbiorczej, które mogą zostać automatycznie przypisane do agenta"
    },
    "SLA": {
      "TITLE": "SLA Policies",
      "SUB_TEXT": "Configure SLA response and resolution times for each conversation priority level.",
      "LOADING": "Loading SLA policies...",
      "FIELDS": {
        "ACTIVE": "Active",
        "TICKET_PRIORITY": "Ticket priority",
        "FIRST_RESPONSE_TIME": "First response time",
        "EVERY_RESPONSE_TIME": "Every response time",
        "RESOLUTION_TIME": "Resolution time",
        "PLACEHOLDER": "e.g. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA policies updated successfully.",
        "ERROR_MESSAGE": "Could not update SLA policies. Please try again."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatic Priority",
      "SUB_TEXT": "Configure automatic priority assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every priority evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "ALL_MESSAGES": "On for all inbound messages",
        "FIRST_MESSAGE": "On for first inbound message only"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Priority Level Configuration",
        "SUB_TEXT": "Configure which priority levels should be enabled and their descriptions. Provide clear criteria for AI to determine when this priority should be assigned."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be marked as {priority} priority",
      "SET_AS_DEFAULT": "Set as default priority",
      "MULTIPLE_DEFAULTS_WARNING": "Only one priority level should be set as default. Please uncheck other defaults."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatic Labeling",
      "SUB_TEXT": "Configure automatic label assignment based on conversation content.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Billing Notice",
        "MESSAGE": "Every labeling evaluation will incur a charge. Please review your plan details for pricing information."
      },
      "MODE": {
        "OFF": "Off",
        "CONVERSATION_OPEN": "On conversation open",
        "CONVERSATION_CLOSE": "On conversation close",
        "ALL_MESSAGES": "On every message - regardless of state",
        "FIRST_MESSAGE": "On first message - regardless of state"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Label Configuration",
        "SUB_TEXT": "Configure which labels should be available for automatic assignment and their descriptions. Provide clear criteria for AI to determine when this label should be applied."
      },
      "DESCRIPTION_LABEL": "Description",
      "DESCRIPTION_PLACEHOLDER": "Describe conversations to be labeled as {label}. If you leave this empty, the label description will be used.",
      "NO_LABELS_MESSAGE": "No labels found. Create labels first to enable automatic labeling.",
      "CREATE_LABELS_LINK": "Create labels"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Ponowna autoryzacja",
      "SUBTITLE": "Twoje połączenie z Facebookiem wygasło, połącz się z nim ponownie, aby kontynuować świadczenie usług",
      "MESSAGE_SUCCESS": "Ponowne połączenie powiodło się",
      "MESSAGE_ERROR": "Wystąpił błąd, spróbuj ponownie"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formularze czatu umożliwiają przechwytywanie informacji o użytkowniku przed rozpoczęciem rozmowy z Tobą.",
      "SET_FIELDS": "Pola formularza czatu wstępnego",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Pola",
        "LABEL": "Etykieta",
        "PLACE_HOLDER": "Etykieta zastępcza",
        "KEY": "Klucz",
        "TYPE": "Typ",
        "REQUIRED": "Wymagane"
      },
      "ENABLE": {
        "LABEL": "Włącz formularz przed czatem",
        "OPTIONS": {
          "ENABLED": "Tak",
          "DISABLED": "Nie"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Wiadomość czatu wstępnego",
        "PLACEHOLDER": "Ta wiadomość będzie widoczna dla użytkowników wraz z formularzem"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Odwiedzający powinni podać swoje imię i nazwisko oraz adres e-mail przed rozpoczęciem czatu"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Ustaw swoją dostępność",
      "SUBTITLE": "Ustaw swoją dostępność na widżecie na czacie",
      "WEEKLY_TITLE": "Ustaw swoje godziny tygodniowe",
      "TIMEZONE_LABEL": "Wybierz strefę czasową",
      "UPDATE": "Zaktualizuj ustawienia godzin pracy",
      "TOGGLE_AVAILABILITY": "Włącz dostępność biznesową dla tej skrzynki odbiorczej",
      "UNAVAILABLE_MESSAGE_LABEL": "Wiadomość niedostępna dla odwiedzających",
      "TOGGLE_HELP": "Enabling business availability will show the available hours on live chat widget even if all the agents are offline. Outside available hours visitors can be warned with a message and a pre-chat form.",
      "DAY": {
        "ENABLE": "Włącz dostępność w tym dniu",
        "UNAVAILABLE": "Niedostępny",
        "HOURS": "godzin",
        "VALIDATION_ERROR": "Czas rozpoczęcia powinien być przed czasem zakończenia.",
        "CHOOSE": "Wybierz"
      },
      "ALL_DAY": "Cały dzień",
      "SAVE_TO_ALL": "Save to All Inboxes",
      "SAVE_TO_ALL_TITLE": "Copy Working Hours",
      "SAVE_TO_ALL_CONFIRM": "The settings from this form (availability toggle, out-of-office message, timezone and working hours) will be copied to all other inboxes except email and phone inboxes. Are you sure you want to continue?",
      "SAVE_TO_ALL_CANCEL": "Cancel",
      "SAVE_TO_ALL_YES": "Yes, Copy to All",
      "SAVE_TO_ALL_SUCCESS": "Working hours copied to all other inboxes successfully",
      "SAVE_TO_ALL_ERROR": "Failed to copy working hours to other inboxes"
    },
    "PHONE": {
      "TITLE": "Phone settings",
      "SUBTITLE": "Configure what calls will show up under this inbox.",
      "UPDATE": "Save settings",
      "EDIT": {
        "SUCCESS_MESSAGE": "Phone settings updates",
        "ERROR_MESSAGE": "Failed to update phone settings"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Phone numbers",
        "SUBTITLE": "Enter phone numbers that belong to this inbox.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Add a phone number"
      }
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Ustaw szczegóły IMAP",
      "NOTE_TEXT": "Aby włączyć SMTP, należy skonfigurować IMAP.",
      "UPDATE": "Aktualizuj ustawienia IMAP",
      "TOGGLE_AVAILABILITY": "Włącz konfigurację IMAP dla tej skrzynki odbiorczej",
      "TOGGLE_HELP": "Enabling IMAP will help the user to receive email",
      "EDIT": {
        "SUCCESS_MESSAGE": "Ustawienia IMAP zostały zaktualizowane",
        "ERROR_MESSAGE": "Nie można zaktualizować ustawień IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adres IP",
        "PLACE_HOLDER": "Adres (Eg: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Zaloguj się",
        "PLACE_HOLDER": "Zaloguj się"
      },
      "PASSWORD": {
        "LABEL": "Hasło",
        "PLACE_HOLDER": "Hasło"
      },
      "ENABLE_SSL": "Włącz SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Ponowna autoryzacja konta MICROSOFT"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Ustaw szczegóły SMTP",
      "UPDATE": "Aktualizuj ustawienia SMTP",
      "TOGGLE_AVAILABILITY": "Włącz konfigurację SMTP dla tej skrzynki odbiorczej",
      "TOGGLE_HELP": "Włączenie SMTP pomoże użytkownikowi wysyłać wiadomości e-mail",
      "EDIT": {
        "SUCCESS_MESSAGE": "Ustawienia SMTP zostały pomyślnie zaktualizowane",
        "ERROR_MESSAGE": "Nie można zaktualizować ustawień SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adres IP",
        "PLACE_HOLDER": "Adres (np. smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Zaloguj się",
        "PLACE_HOLDER": "Zaloguj się"
      },
      "PASSWORD": {
        "LABEL": "Hasło",
        "PLACE_HOLDER": "Hasło"
      },
      "DOMAIN": {
        "LABEL": "Domena",
        "PLACE_HOLDER": "Domena"
      },
      "ENCRYPTION": "Szyfrowanie",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Otwórz tryb weryfikacji SSL",
      "AUTH_MECHANISM": "Uwierzytelnianie"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Dostarczalność e-maili (DNS)",
      "SUB_TITLE": "W każdy dzień roboczy sprawdzamy rekordy SPF, DKIM, DMARC i MX domeny {domain}. Gdy coś powoduje, że serwery odbiorców odrzucają Państwa odpowiedzi lub kierują je do spamu, administratorzy otrzymują e-mail z instrukcją naprawy.",
      "RUN": "Uruchom sprawdzanie",
      "RUN_SUCCESS": "Sprawdzanie DNS zakończone",
      "RUN_ERROR": "Nie udało się uruchomić sprawdzania DNS, spróbuj ponownie",
      "NOT_CHECKED": "Jeszcze nie sprawdzono.",
      "CHECKED_AT": "Ostatnie sprawdzenie: {time}.",
      "DNS_UNAVAILABLE": "Podczas ostatniego sprawdzania serwery nazw domeny nie odpowiedziały. Poniższy wynik pochodzi z wcześniejszego sprawdzenia.",
      "SENDER": {
        "SMTP": "Odpowiedzi są wysyłane przez {host}.",
        "PLATFORM": "Odpowiedzi są wysyłane przez nasze serwery pocztowe."
      },
      "STATUS": {
        "OK": "Wszystkie rekordy są w porządku",
        "WARNING": "Niektóre rekordy można poprawić",
        "ERROR": "Odpowiedzi mogą nie docierać do odbiorców",
        "UNKNOWN": "Nieznany"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Ostrzeżenie"
      },
      "FIX": "Napraw to za pomocą tego rekordu DNS:",
      "RECORD_TYPE": "Typ",
      "RECORD_HOST": "Nazwa",
      "RECORD_VALUE": "Wartość",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Brak rekordu SPF",
          "DESCRIPTION": "Domena nie określa, które serwery mogą wysyłać jej pocztę. Wiele serwerów pocztowych traktuje wtedy Państwa odpowiedzi jako spam. Dodaj rekord SPF, który zezwala na {sender}."
        },
        "spf_multiple": {
          "TITLE": "Domena ma {count} rekordów SPF",
          "DESCRIPTION": "Domena może mieć tylko jeden rekord SPF. Przy większej liczbie serwery odbiorców ignorują SPF i często odrzucają pocztę. Połącz je w jeden rekord."
        },
        "spf_not_authorized": {
          "TITLE": "SPF nie zezwala na serwer, który wysyła Państwa odpowiedzi",
          "DESCRIPTION": "Państwa odpowiedzi są wysyłane przez {sender}, ale rekord SPF domeny go nie zawiera. Obecny rekord: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Rekord SPF wymaga zbyt wielu zapytań DNS",
          "DESCRIPTION": "Serwery odbiorców przestają sprawdzać SPF po {limit} zapytaniach DNS, a {sender}, który wysyła Państwa odpowiedzi, jest osiągany dopiero po {lookups}. Państwa odpowiedzi nie przechodzą SPF. Przenieś {sender} na początek rekordu i usuń wpisy include, których domena już nie używa."
        },
        "spf_lookups_others": {
          "TITLE": "Część nadawców w rekordzie SPF przekracza limit zapytań",
          "DESCRIPTION": "Rekord SPF wymaga {lookups} zapytań DNS, a serwery odbiorców przestają sprawdzać po {limit}. Państwa odpowiedzi są dopasowywane na czas i przechodzą, ale poczta od tych nadawców nie przechodzi SPF: {senders}. Usuń wpisy include, których domena już nie używa."
        },
        "spf_malformed": {
          "TITLE": "Rekord SPF jest uszkodzony",
          "DESCRIPTION": "Serwery odbiorców nie mogą odczytać rekordu SPF domeny, więc nie chroni on Państwa odpowiedzi. Problem dotyczy: {terms}. Zastąp rekord poprawionym."
        },
        "dkim_missing": {
          "TITLE": "Podpis DKIM nie jest skonfigurowany",
          "DESCRIPTION": "Nie znaleźliśmy klucza DKIM pod adresem {selectors}. Bez niego Państwa odpowiedzi nie są podpisane i częściej trafiają do spamu. Włącz podpisywanie DKIM dla domeny u swojego dostawcy poczty."
        },
        "dmarc_missing": {
          "TITLE": "Brak rekordu DMARC",
          "DESCRIPTION": "Więksi dostawcy poczty, tacy jak Gmail i Microsoft, oczekują rekordu DMARC. Bez niego Państwa odpowiedzi częściej trafiają do spamu."
        },
        "dmarc_fails": {
          "TITLE": "DMARC nakazuje odbiorcom odrzucać Państwa odpowiedzi",
          "DESCRIPTION": "Polityka DMARC domeny to „{policy}”, a Państwa odpowiedzi nie przechodzą ani SPF, ani DKIM, więc odbiorcy je odrzucają lub przenoszą do spamu. Napraw SPF i DKIM powyżej."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokuje odpowiedzi wysyłane przez nasze serwery pocztowe",
          "DESCRIPTION": "Ta skrzynka wysyła odpowiedzi przez nasze serwery pocztowe, ale polityka DMARC domeny to „{policy}”, więc odbiorcy je odrzucają lub przenoszą do spamu. Skonfiguruj dla tej skrzynki SMTP własnego serwera pocztowego."
        },
        "mx_missing": {
          "TITLE": "Domena nie ma rekordu MX",
          "DESCRIPTION": "Bez rekordu MX nikt nie może wysyłać poczty na adres w tej domenie, więc klienci nie mogą odpowiadać na Państwa wiadomości."
        }
      }
    },
    "NOTE": "Uwaga: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Awatar strony internetowej",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Awatar został pomyślnie usunięty",
              "ERROR_MESSAGE": "Wystąpił błąd, spróbuj ponownie"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Nazwa strony",
          "PLACE_HOLDER": "Wprowadź nazwę swojej strony (np. Acme Inc)",
          "ERROR": "Wprowadź poprawną nazwę witryny"
        },
        "WELCOME_HEADING": {
          "LABEL": "Nagłówek powitalny",
          "PLACE_HOLDER": "Cześć!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Tagline powitalny",
          "PLACE_HOLDER": "Łatwo się z nami połączyć. Zapytaj nas o coś lub podziel się swoją opinią."
        },
        "REPLY_TIME": {
          "LABEL": "Czas odpowiedzi",
          "IN_A_FEW_MINUTES": "W ciągu kilku minut",
          "IN_A_FEW_HOURS": "W ciągu kilku godzin",
          "IN_A_DAY": "W ciągu dnia"
        },
        "WIDGET_COLOR_LABEL": "Kolor widżetu",
        "WIDGET_BUBBLE_POSITION_LABEL": "Pozycja bąbelka widgetu",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maksymalna wysokość nieprzeczytanych wiadomości (px)",
          "PLACE_HOLDER": "Bez limitu",
          "HELP_TEXT": "Ogranicz maksymalną wysokość okna nieprzeczytanych wiadomości w pikselach. Pozostaw puste, aby zachować domyślne działanie (bez limitu)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Typ bąbelka widgetu",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Porozmawiaj z nami",
          "LABEL": "Tytuł programu uruchamiającego bąbelki widżetów",
          "PLACE_HOLDER": "Porozmawiaj z nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Aktualizacja ustawień widżetu",
          "API": {
            "SUCCESS_MESSAGE": "Ustawienia widżetu zostały pomyślnie zaktualizowane",
            "ERROR_MESSAGE": "Nie można zaktualizować ustawień widżetu"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Podgląd",
          "SCRIPT": "Skrypt"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Lewo",
          "RIGHT": "Prawo"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Rozszerzony bąbelek"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Domyślny",
        "CHAT": "Czat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Zwykle odpowiadamy w ciągu paru minut",
        "IN_A_FEW_HOURS": "Zwykle odpowiadamy w ciągu paru godzin",
        "IN_A_DAY": "Zwykle odpowiadamy w przeciągu jednego dnia"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Rozpocznij rozmowę",
        "CHAT_INPUT_PLACEHOLDER": "Wpisz treść wiadomości"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Jesteśmy online",
          "OFFLINE": "W tej chwili jesteśmy niedostępni"
        },
        "USER_MESSAGE": "Cześć",
        "AGENT_MESSAGE": "Witam"
      },
      "BRANDING_TEXT": "Napędzany przez JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Inni dostawcy"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Strona internetowa",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "Kanał API",
      "PHONE": "Telefon SIP",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    }
  }
}
